import { useTranslation } from "react-i18next";
import RadioButton from "components/Form/RadioButton";

export default function RuleMessageOption({
  id,
  target,
  label,
  isChecked,
  onChange,
}) {
  const [t] = useTranslation();
  return (
    <div
      className="set"
      id={id}
      data-bs-toggle="tab"
      data-bs-target={`#${target}`}
      role="tab"
      onClick={onChange}
    >
      <RadioButton
        id={id}
        label={t(`createRuleEngine.settingsTab.messageOptions.${label}`)}
        isChecked={isChecked}
        onChange={onChange}
      />
    </div>
  );
}
